<template>
  <div class="device__status">
    <div
      v-if="deviceName === 'RC'"
      class="device__switch-state"
      :class="switchState ? `device__switch-state--${switchState.toLowerCase()}` : ''"
    >
      {{ switchState || defaultSwitchState }}
    </div>
    <div
      v-b-tooltip.hover
      class="device__online-status"
      :class="{ 'device__online-status--on': isOnline }"
      :title="isOnline ? 'Online' : 'Offline'"
    />
  </div>
</template>

<script>
const DEFAULT_SWITCH_STATE = 'UNKNOWN';

export default {
  name: 'DeviceStatus',
  props: {
    isOnline: Boolean,
    deviceName: String,
    switchState: {
      type: String,
      default: DEFAULT_SWITCH_STATE
    }
  },
  data() {
    return {
      defaultSwitchState: DEFAULT_SWITCH_STATE
    };
  }
};
</script>
